import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installGlobalCrashReporter } from "@/lib/globalCrashReporter";
import { installDomReconcilerPatch } from "@/lib/domReconcilerPatch";

// iter100: patcha Node.removeChild/insertBefore PRIMA di qualsiasi cosa,
// così anche i primi render di React sono protetti da estensioni tipo Google Translate
installDomReconcilerPatch();
// iter91b: installa il crash reporter GLOBALE prima di montare React
// così cattura anche errori che avvengono durante il boot iniziale
installGlobalCrashReporter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
